import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HomeIcon, CreditCardIcon, TrendingUpIcon, SettingsIcon } from 'lucide-react';
import { BottomNav, NavTab } from '../ui/BottomNav';
import { Sidebar } from '../ui/Sidebar';
import { TopBar } from '../ui/TopBar';
interface AppLayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tabId: string) => void;
  pageTitle?: string;
  notificationCount?: number;
  consentBadgeCount?: number;
}
const TABS: NavTab[] = [{
  id: 'home',
  label: 'Home',
  icon: HomeIcon
}, {
  id: 'accounts',
  label: 'Accounts',
  icon: CreditCardIcon
}, {
  id: 'insights',
  label: 'Insights',
  icon: TrendingUpIcon
}, {
  id: 'settings',
  label: 'Settings',
  icon: SettingsIcon
}];
export function AppLayout({
  children,
  activeTab,
  onTabChange,
  pageTitle,
  notificationCount = 0,
  consentBadgeCount = 0
}: AppLayoutProps) {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  // Add badge to Settings tab if there are pending consents
  const tabsWithBadges = TABS.map(tab => tab.id === 'settings' && consentBadgeCount > 0 ? {
    ...tab,
    badge: consentBadgeCount
  } : tab);
  return <div className="min-h-screen bg-gray-50" data-id="element-96">
      {/* Desktop Sidebar */}
      <Sidebar tabs={tabsWithBadges} activeTab={activeTab} onTabChange={onTabChange} data-id="element-97" />

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-98">
        {showMobileMenu && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowMobileMenu(false)} className="fixed inset-0 bg-black/50 z-40 md:hidden" data-id="element-99" />
            <motion.div initial={{
          x: -280
        }} animate={{
          x: 0
        }} exit={{
          x: -280
        }} transition={{
          type: 'spring',
          damping: 30,
          stiffness: 300
        }} className="fixed left-0 top-0 bottom-0 w-64 bg-white z-50 md:hidden" data-id="element-100">
              <Sidebar tabs={tabsWithBadges} activeTab={activeTab} onTabChange={tabId => {
            onTabChange(tabId);
            setShowMobileMenu(false);
          }} data-id="element-101" />
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Main Content Area */}
      <div className="md:ml-64" data-id="element-102">
        {/* Top Bar */}
        <TopBar title={pageTitle} notificationCount={notificationCount} onMenuClick={() => setShowMobileMenu(true)} onSearchClick={() => console.log('Search clicked')} onNotificationClick={() => console.log('Notifications clicked')} onProfileClick={() => console.log('Profile clicked')} data-id="element-103" />

        {/* Page Content */}
        <main className="min-h-[calc(100vh-4rem)] pb-20 md:pb-6" data-id="element-104">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6" data-id="element-105">
            <AnimatePresence mode="wait" data-id="element-106">
              <motion.div key={activeTab} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.2
            }} data-id="element-107">
                {children}
              </motion.div>
            </AnimatePresence>
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <BottomNav tabs={tabsWithBadges} activeTab={activeTab} onTabChange={onTabChange} data-id="element-108" />
    </div>;
}